/**
 * Section: Video hero
 * ------------------------------------------------------------------------------
 * Configured section to display a background video with text overlay.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections.
 *
 * @namespace imageVideoHero
 */
import {register} from '@shopify/theme-sections';
import imageVideo from '~/components/image-video';

/**
 * Register the `video-hero` section type.
 */
register('image-video-hero', {

  /**
   * Set cached node selectors.
   */
  setNodeSelectors() {
    this.container = document.querySelector(`#ImageVideoHero-${this.id}`);
  },

  /**
   * Instantiate events on video player.
   */
  init() {
    this.setNodeSelectors();
    imageVideo({container: this.container}).init();
  },

  /**
   * Callback function when section is loaded via `sections.load()` or
   * by the Theme Editor `shopify:section:load` event.
   */
  onLoad() {
    this.init();
  },
});
